import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createLineFailed,
  createLineRequested,
  createLineSucceeded,
  deleteLineFailed,
  deleteLineRequested,
  deleteLineSucceeded,
  updateLineFailed,
  updateLineRequested,
  updateLineSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createLineRequest(siteId, localId, data) {
  yield put(
    createLineRequested(localId, {
      ...data,
      siteId,
    }),
  );

  try {
    const { item } = yield call(request, api.createLine, siteId, data);

    const action = createLineSucceeded(localId, item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createLineFailed(localId, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateLineRequest(id, data) {
  yield put(updateLineRequested(id, data));

  try {
    const { item } = yield call(request, api.updateLine, id, data);

    const action = updateLineSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateLineFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteLineRequest(id) {
  yield put(deleteLineRequested(id));

  try {
    const { item } = yield call(request, api.deleteLine, id);

    const action = deleteLineSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteLineFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
